import { Fragment } from "react";

import If from "~/core/ui/If";

import KeySequence from "../../Keys/KeySequence";
import KeyStack from "../../Keys/KeyStack";
import { ButtonVariant } from "../enums";
import { ButtonShortcutKey } from "../interfaces";

export const Shortcut = ({
  variant,
  keys,
  buttonVariant,
  disabled,
}: ButtonShortcutKey & {
  buttonVariant: ButtonVariant;
  disabled?: boolean;
}) => {
  const isStack = variant === "stack";
  const isSequence = variant === "sequence";

  const isWhite =
    buttonVariant === ButtonVariant.PRIMARY ||
    buttonVariant === ButtonVariant.ACCENT ||
    buttonVariant === ButtonVariant.DANGER ||
    buttonVariant === ButtonVariant.WARNING ||
    buttonVariant === ButtonVariant.SUCCESS;

  const disabledStatus = disabled ? "disabled" : undefined;

  return (
    <Fragment>
      <If condition={isStack}>
        <KeyStack keys={keys} status={disabledStatus} isWhite={isWhite} />
      </If>
      <If condition={isSequence}>
        <KeySequence keys={keys} status={disabledStatus} isWhite={isWhite} />
      </If>
    </Fragment>
  );
};
